import { getCurrentUser, getUserClients, isClientUser } from '@abovo/shared-auth';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

export const singleClientRedirectGuard: CanActivateFn = () => {
   const store = inject(Store);
   const router = inject(Router);

   return store.select(getCurrentUser).pipe(
      filter((user) => !!user),
      take(1),
      map((user) => {
         const isClient = store.selectSignal(isClientUser)();
         const hasMultipleClients = (store.selectSignal(getUserClients)()?.length ?? 0) > 1;
         const firstClient = user.clients?.[0];
         if (isClient && !hasMultipleClients && firstClient) {
            return router.createUrlTree(['/crm/account', firstClient.id]);
         }
         return true;
      }),
   );
};
